// extracted by mini-css-extract-plugin
export var bodyRow = "_f9-d";
export var cardColumns = "_f9-e";
export var ellipsesOverflow = "_f9-2";
export var flatBottomCorners = "_f9-3";
export var flatTopCorners = "_f9-4";
export var headerActionsDropdown = "_f9-f";
export var headerBottomRow = "_f9-c";
export var headerTopRow = "_f9-b";
export var orderDetailsWrapper = "_f9-0";
export var orderInfoContainer = "_f9-1";
export var productDetails = "_f9-9";
export var productImage = "_f9-5";
export var responsiveTable = "_f9-8";
export var shipmentContainer = "_f9-a";
export var tableBottomLeft = "_f9-6";
export var tableBottomRight = "_f9-7";